import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../../../Confirmation'
import { useDocFlowContext } from '../../../DocFlow.hooks'

export function useGetClickHandlers({
  nextPhaseModalDescription = 'DocumentStapling.AttentionModalNextPhaseTextKey',
  onArchive,
  onClickNext,
  onNextPhase,
  onRestore,
  ...restProps
}) {
  const { handleCloseModal, setModal } = useDocFlowContext()

  const { t } = useTranslation()

  function handleClickNextPhase() {
    onClickNext
      ? onClickNext()
      : setModal(
          <ConfirmationModal
            {...restProps}
            actionButtonsProps={{
              submitText: t('DocumentStapling.AttentionModalNextPhaseBtnKey'),
            }}
            description={t(nextPhaseModalDescription)}
            title={t('DocumentStapling.AttentionModalTitleKey')}
            onCancel={handleCloseModal}
            onSubmit={onNextPhase}
          />
        )
  }

  function handleClickArchive() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('DocFlow.AttentionModalArchiveBtnKey'),
        }}
        description={t('DocFlow.AttentionModalArchiveTextKey')}
        title={t('DocFlow.AttentionModalTitleKey')}
        onCancel={handleCloseModal}
        onSubmit={onArchive}
      />
    )
  }

  function handleClickRestore() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('DocFlow.AttentionModalRestoreBtnKey'),
        }}
        description={t('DocFlow.AttentionModalRestoreTextKey')}
        title={t('DocFlow.AttentionModalTitleKey')}
        onCancel={handleCloseModal}
        onSubmit={onRestore}
      />
    )
  }

  return { handleClickArchive, handleClickNextPhase, handleClickRestore }
}
